import { Injectable } from '@angular/core';
import { CallbackBody } from '@callback/const';
import { select, Store } from '@ngrx/store';
import { ProcessSelectors, StateUtils, StateWithProcess } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CallBackActions } from '../store';
import { CALLBACK_PROCESS_ID, StateWithCallback } from '../store/callback-state';

@Injectable({
  providedIn: 'root',
})
export class CallbackService {
  constructor(private store: Store<StateWithCallback | StateWithProcess<void>>) {}

  requestCallback(callbackData: CallbackBody): void {
    this.store.dispatch(new CallBackActions.CallbackRequest(callbackData));
  }

  resetProcess(): void {
    this.store.dispatch(new CallBackActions.CallbackRequestReset());
  }

  getProcess(): Observable<StateUtils.LoaderState<void>> {
    return this.store.pipe(select(ProcessSelectors.getProcessStateFactory(CALLBACK_PROCESS_ID)));
  }
}
